module.exports = __webpack_public_path__ + "static/swatch-6ac06fad1b1e0bcbee8686034986e181.png";